module.exports = __webpack_public_path__ + "images/areamap/map_sp_f7346328add15d9fdec16abc36402159.jpg";